import React, { useEffect, useState } from 'react';
import './ValidationReferencesMOQ.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faCheck, faClose, faInfoCircle, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import CURRENCY from 'utils/constants/currency';
import { Trans, useTranslation } from 'react-i18next';
import Pagination from 'components/pagination/Pagination';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IParts } from 'interfaces/price';
import QuantityInput from 'components/inputs/QuantityInput/QuantityInput';
import { IFileRow } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';
import { formatNumberWithSpaces } from 'utils/utils';
import { notify } from 'utils/marketplace';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};


type IOption = {
  label: string;
  value: string;
  logo?: string;
};
type FormValues = {
  selectedSupplier: IOption | null;
};

const ValidationReferencesMOQ: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<Array<IParts>>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const [dataPagination, setDataPagination] = useState<Array<IParts>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [suppliers, setSuppliers] = useState<IOption[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<string>('');
  const [isLoadingSuppliers, setIsLoadingSuppliers] = useState(false);
  const dispatch = useDispatch();

  const { setValue, control } = useForm<FormValues>({
    defaultValues: {
      selectedSupplier: null,
    },
  });

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesMOQ') {

      setIsLoadingSuppliers(true);
      const arrayQUANTITY = getMOQandUV();

      setData(arrayQUANTITY);

    }
  }, [props.stepModalNext]);


  const getMOQandUV = () => {
    const data = proformaFile.partsWithReplacements || [];

    const minQuantityFiltered = data.map((item) => {
      const updatedParts = item.parts.filter((part) =>
        (!isNaN(Number(part.min_quantity)) && (Number(part.quantity) < Number(part.min_quantity)))
        || part.quantity % part.uv != 0
      );

      return { ...item, parts: updatedParts };
    }
    ).filter((item) => item.parts.length > 0);

    return minQuantityFiltered.map((item) => item.parts).flat();
  };

  useEffect(() => {
    setIsLoadingSuppliers(true);
    const suppliers: IOption[] = data.reduce((acc: IOption[], row) => {
      const supplierName = row.supplier_name || row.name || '-';
      const supplierValue = row.codfou || row.supplier_name || row.name || '-';


      if (!acc.find((s) => s.value === supplierValue)) {
        acc.push({
          label: supplierName,
          value: supplierValue,
          logo: row.supplier_logo || '/images/car-part-placeholder-big.png',
        });
      }

      return acc;
    }, []);

    setSuppliers(suppliers);
    setIsLoadingSuppliers(false);


  }, [data]);

  useEffect(() => {
    if (suppliers.length && selectedSupplier !== '') {
      let defaultSupplier;


      const filteredData = data.filter((item) => item.codfou === selectedSupplier);

      if (filteredData.length > 0) {
        defaultSupplier = suppliers.find((supplier) => supplier.value === selectedSupplier);
      } else {
        defaultSupplier = suppliers[0];
      }

      setSelectedSupplier(defaultSupplier?.value);

      setValue('selectedSupplier', defaultSupplier);


    }
  }, [suppliers]);

  useEffect(() => {
    if (data.length > 0) {
      let filteredData;

      if (selectedSupplier === '') {
        filteredData = data;
      } else {
        filteredData = data.filter((item) => item.codfou === selectedSupplier);
      }

      const total = filteredData.length;

      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setTotalPages(Math.ceil(total / itemsPerPage));
      setDataPagination(filteredData.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage, selectedSupplier]);

  const handlePageClick = (page: number) => {

    setCurrentPage(page);

  };


  const setValueItems = (value: { id: number | string; index: number; quantity: number }) => {


    const updatedData = data.map((item) => {

      if (item.index === value.index && item.reference === value.id) {


        return {
          ...item,
          quantity: value.quantity,
          total: (Number(item.price) * value.quantity).toFixed(2), // Update the total based on the new quantity
        };
      }

      return item;

    });


    const parts = proformaFile.partsWithReplacements || [];

    const updatedParts = parts.map((item) => {
      const updatedItem = { ...item };

      updatedItem.parts = item.parts.map((part) => {
        if (part.index === value.index && part.reference === value.id) {

          return {
            ...part,
            quantity: value.quantity,
            total: (Number(part.price) * value.quantity).toFixed(2), // Update the total based on the new quantity
          };
        }

        return part;
      });

      return updatedItem;
    }
    );


    localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, partsWithReplacements: updatedParts }));


    setData(updatedData);
  };

  const show = (id: string, type, event: React.MouseEvent) => {
    event.stopPropagation();
    const el = document.getElementById(String(id));

    if (el) {
      el.style.display = type;
    }
  };

  const removeRow = (reference, index, codfou) => {


    const updatedData = data.filter(
      (part) => !(part.reference === reference && part.index === index && part.codfou === codfou)
    );


    const parts = proformaFile.partsWithReplacements || [];

    const updatedParts = parts.map((item) => {

      const updatedItem = { ...item };

      updatedItem.parts = item.parts.filter(
        (part) => !(part.reference === reference && part.index === index && part.codfou === codfou)
      );

      return updatedItem;

    }
    );

    localStorage.setItem('proformaFileInProgress', JSON.stringify({
      ...proformaFile,
      count: proformaFile.count - 1,
      partsWithReplacements: updatedParts.filter((item) => item.parts.length !== 0)
    }));

    setData(updatedData);

    if (currentPage === 1) {
      setCurrentPage(currentPage);
    }
    // Dacă pagina curentă e mai mare decât totalul de pagini (după ștergere), mergi pe ultima pagină validă
    else if (currentPage > Math.ceil(updatedData.length / itemsPerPage)) {
      setCurrentPage(Math.ceil(updatedData.length / itemsPerPage));
    } else {
      setCurrentPage(currentPage);
    }

    if (updatedData.length === 0) {
      props.setStepModal('ValidationReferencesFranco');
    }
  };

  const handleSubmit = () => {

    const validateData = getMOQandUV();

    if (validateData.length > 0) {
      notify(t('_error_MOQ_and_UV'), 'error', t('_error'));

      return;
    }


    const dataProformaFile = proformaFile.partsWithReplacements || [];


    const maxQuantityFiltered = dataProformaFile.map((item) => {
      const updatedParts = item.parts.filter((part) => !isNaN(Number(part.min_quantity)) && (Number(part.min_quantity) <= Number(part.quantity)));

      return { ...item, parts: updatedParts };
    }
    ).filter((item) => item.parts.length > 0);


    const lowQuantityFiltered = dataProformaFile.map((item) => {
      const updatedParts = item.parts.filter((part) => !isNaN(Number(part.min_quantity)) && (Number(part.min_quantity) > Number(part.quantity)));

      return { ...item, parts: updatedParts };
    }
    ).filter((item) => item.parts.length > 0);

    const lowQuantity = lowQuantityFiltered.map((item) => item.parts).flat();
    const newRows: IFileRow[] = [];

    if (lowQuantity.length > 0) {

      const maxIndex = proformaFile.rows.length > 0 ? Math.max(...proformaFile.rows.map((row) => row.data[0])) : 0;

      lowQuantity.map((item, index) => {

        const newItem = {
          data: [maxIndex + index + 1, '', item.reference_internal, item.codfou, item.reference_full, '', item.quantity, item.price],
          info:
          {
            'is_manufacturer': item.source === 'sup' ? 0 : 1,
            'supplier_id': item.supplier_id,
            'current_price': item.current_price,
            'description': item.description,
            'supplier_name': item.name,
            'codfou': item.codfou,
            'reference': item.reference,
            'price_from_file': item.price_from_file,
            'itgr': item.itgr,
            'supplier_logo': item.supplier_logo,
            'franco': item.franco,
          },

          section: 'REFERENCE_MOQ',
          isRemovedByUser: true

        };


        newRows.push(newItem);
      }
      );
    }

    localStorage.setItem('proformaFileInProgress', JSON.stringify({
      ...proformaFile,
      rows: [...(proformaFile.rows || []), ...newRows],
      partsWithReplacements: maxQuantityFiltered.filter((item) => item.parts.length !== 0)
    }));

    const countMinQuantity = data.filter((item) => item.min_quantity != null && (item.min_quantity > item.quantity!)).length;

    if (countMinQuantity === 0) {
      props.setStepModal('ValidationReferencesFranco');
    } else {
      props.setStepModal('ValidationReferencesMOQComment');
    }

  };

  return (
    <div className="validation-custumer-order-moq-modal" >
      <div className="close upload_order_info_moq_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>


      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_validation_MOQ')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_MOQ_message"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <div className="div-select-all">
            {suppliers.length > 1 && <div className="validation-customer-modal-select">
              {t('_supplier')}

              <Controller
                control={control}
                name="selectedSupplier"
                defaultValue={null}
                render={({ field: { onChange, value } }) => (
                  <Select
                    value={value}
                    className="validation-customer-modal-select-input"
                    onChange={(val) => {
                      onChange(val);
                      setSelectedSupplier(val?.value || '');
                      setCurrentPage(1);
                    }}
                    options={suppliers}
                    formatOptionLabel={(option) => (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {option.logo && <img src={option.logo ? option.logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src = '/images/car-part-placeholder-big.png'; }} alt="Logo" height={18} />}
                        <span>{option.label}</span>
                      </div>
                    )}
                    placeholder={t('_select') + ' ' + t('_supplier')}
                    isClearable={false}
                    menuPlacement="top"
                    menuPosition="fixed"
                    isDisabled={suppliers.length === 1}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 50 }) }}
                    isSearchable={false}
                    isLoading={isLoadingSuppliers}
                  />
                )}
              />


            </div>}


          </div>
          <table className="validation-customer-modal-table">
            <thead>
              <tr>
                <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                <th >{t('_brand')}</th>
                <th >{t('_quantity_order')}</th>
                <th >{t('_moq')}</th>
                <th >{t('_unit_price')}</th>
                <th ></th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row) => {
                  const validate_uv = row.quantity! % row.uv != 0;

                  return (

                    <tr key={row.reference! + row.index!}>
                      <td className="text-align-left">{row.description ? `${row.reference ?? ''} / ${row.description}` : row.reference ?? ''}</td>
                      <td >
                        <div className="brand">
                          <div>
                            <img src={row?.supplier_logo ? row?.supplier_logo : '/images/car-part-placeholder-big.png'} onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = '/images/car-part-placeholder-big.png';
                            }} alt="provider-logo" height={16}
                            /> </div>
                          {/*<div>{row.supplier_name || row.name}</div>*/}
                          <div></div>
                        </div>
                      </td>
                      <td>
                        <QuantityInput
                          value={row.quantity!}
                          index={row.index!}
                          setValueItems={setValueItems}
                          id={String(row.reference!)}
                          uv={row.uv}
                          red={validate_uv}
                          calculateUV

                        />
                        {
                          row.uv && row.uv > 1 && (
                            <div className="uv-info">
                              <span className="color-yellow">UV * {row.uv}</span>
                              <div key={row.reference! + row.index} className="uv-info-tooltip">
                                <FontAwesomeIcon
                                  icon={faInfoCircle}
                                  className="uv-icon"
                                  onMouseEnter={(event) =>
                                    show(String('uv' + String(row.reference! + row.index)), 'block', event)
                                  }
                                  onMouseLeave={(event) =>
                                    setTimeout(() => {
                                      show(String('uv' + String(row.reference! + row.index)), 'none', event);
                                    }, 100)
                                  }
                                />
                                <div
                                  id={String('uv' + String(row.reference! + row.index))}
                                  className="uv-tooltip"
                                >
                                  {`${t('_packaging_of_the_items')}`}
                                </div>
                              </div>

                            </div>
                          )}
                      </td>
                      <td className={Number(row.min_quantity) <= Number(row.quantity!) ? 'validate' : 'not-validate'}>{Number(row.min_quantity)}</td>
                      <td> {row.price ? `${formatNumberWithSpaces(Number(row.price).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'} </td>
                      <td className="text-align-right">

                        <div className="remove" onClick={(event) => show('delete' + row.index + row.reference, 'block', event)} ><FontAwesomeIcon icon={faTrashCan} />
                          <div className="tooltip-order"
                            id={String('delete' + row.index + row.reference)}
                            onMouseLeave={(event) =>
                              setTimeout(() => {
                                show(String('delete' + row.index + row.reference), 'none', event);
                              }, 100)
                            }
                          >
                            <div className="tooltip_lable">
                              <button className="yes" onClick={() => removeRow(row.reference, row.index, row.codfou)}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                              <button className="no" onClick={(event) => show('delete' + row.index + row.reference, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>);
                }
                ))
                :
                <tr>
                  <td colSpan={6} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {totalPages > 1 && (
            <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
          )}
        </div>
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_info_moq" text={t('_confirm_order_with_the_new_quantities')} onClick={() => { handleSubmit(); }} />

            <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_moq_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div>
    </div >
  );

};

ValidationReferencesMOQ.displayName = 'ValidationReferencesMOQ';

export default ValidationReferencesMOQ;